// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.6.6-1973-g3074e322",
    "hash": "g3074e322",
    "distance": 1973,
    "tag": "v1.6.6",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.6.6",
        "major": 1,
        "minor": 6,
        "patch": 6,
        "prerelease": [],
        "build": [],
        "version": "1.6.6"
    },
    "suffix": "1973-g3074e322",
    "semverString": "1.6.6+1973.g3074e322",
    "version": "1.6.6"
};
/* tslint:enable */
